import { useEffect, useRef } from 'react'
import * as Ably from 'ably'

function useRealtimeClient(params = {}, deps = []){
  const { apiKey, disabled } = params

  const realtimeClientRef = useRef(null)

  useEffect(() => {
    const missingKeys = deps ? deps.filter(i => (i === undefined || i === null)) : []

    if (!disabled && !missingKeys.length && apiKey){
      const client = new Ably.Realtime(apiKey)
      realtimeClientRef.current = client
    }

    // Close Connection
    return () => {
      if (realtimeClientRef.current) realtimeClientRef.current.close()
    }
  }, [...deps, apiKey, disabled])

  return {
    clientRef: realtimeClientRef,
  }
}

export default useRealtimeClient
